import React from 'react'
import styled from 'styled-components'
import { getImageUrl } from 'lib/image/imageUtils'

const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  overflow: hidden;
`

const Video = styled.video`
  height: 100%;
  width: 100%;
  object-fit: cover;
`

interface Props {
  videoId: string
  thumbnailImageId?: string
  className?: string
}

export function GenericVideoBackground({ videoId, thumbnailImageId, className }: Props) {
  const posterUrl = thumbnailImageId ? getImageUrl(thumbnailImageId, { width: 1920, quality: 'good' }) : undefined

  return (
    <Container className={className}>
      <Video
        controls={false}
        autoPlay
        playsInline
        loop
        muted
        poster={posterUrl}
      >
        <source src={videoId} type="video/mp4" />
      </Video>
    </Container>
  )
}
